var map = {
	"./ask.svg": 4229,
	"./inputVoice.svg": 8378,
	"./no_data.svg": 892,
	"./official.svg": 1893,
	"./outTime.svg": 1780,
	"./play.svg": 2283,
	"./playVoice.svg": 693,
	"./play_01.svg": 2926,
	"./return.svg": 2658,
	"./sift.svg": 8132,
	"./translation.svg": 1689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;